var Field = function (name, type, required, hint, onChange, def) {
    var view;
    if (type === 'number') {
        view = (
            <div className="input" style={{display: 'inline-block'}} key={name}>
                <input style={ {width: '100%'}} type={type} required={false} placeholder={hint} name={name} autoComplete="off" onChange={onChange} />
            </div>
        )

        return view
    }

    if (type !== 'textarea') {
        if (type === 'date') {
            view = (
                <div className="input" key={name}>
                    <input type={type} max="2028-12-31" required={false} placeholder={hint} name={name} autoComplete="off" onChange={onChange} />
                </div>
            )

            return view
        }

        view = (
            <div className="input" key={name}>
                <input type={type} required={false} placeholder={hint} name={name} autoComplete="off" onChange={onChange} />
            </div>
        )
    } else {
        view = (
            <div className="input" key={name}>
                <span className="subtitle">{hint}</span><br />
                <textarea name={name} required={false} autoComplete="off" defaultValue={def} onChange={onChange}></textarea>
            </div>
        )
    }

    return view;
}

export default Field